/* eslint-disable camelcase */
import { Module } from 'vuex'
import { RootState } from '../types'
import api from '@/api/axios'

export interface Payment {
  id: number
  date: string
  tenant_name: string
  invoice_number: string
  amount: number
  method: 'Cash' | 'Mobile Money' | 'Bank Transfer'
}

export interface PaymentsState {
  list: Payment[]
  loading: boolean
}

const payments: Module<PaymentsState, RootState> = {
  namespaced: true,

  state: (): PaymentsState => ({
    list: [],
    loading: false
  }),

  getters: {
    all: (state) => state.list,
    loading: (state) => state.loading
  },

  mutations: {
    SET_LIST (state, list: Payment[]) { state.list = list },
    SET_LOADING (state, val: boolean) { state.loading = val },
    ADD (state, payment: Payment) { state.list.unshift(payment) }
  },

  actions: {
    async fetchAll ({ commit }, params?: { month?: string; property_id?: number }) {
      commit('SET_LOADING', true)
      try {
        const { data } = await api.get('/payments', { params })
        commit('SET_LIST', data.data ?? data)
      } finally {
        commit('SET_LOADING', false)
      }
    }
  }
}

export default payments
